import { render } from "./EventsRegisterPopin.vue?vue&type=template&id=c6307de4&scoped=true&ts=true"
import script from "./EventsRegisterPopin.vue?vue&type=script&lang=ts"
export * from "./EventsRegisterPopin.vue?vue&type=script&lang=ts"

import "./EventsRegisterPopin.vue?vue&type=style&index=0&id=c6307de4&lang=stylus"
import "./EventsRegisterPopin.vue?vue&type=style&index=1&id=c6307de4&lang=stylus&scoped=true"

import exportComponent from "/builds/web-factory/barsmart/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6307de4"]])

export default __exports__